import "./WhatsAppButton.css";

export default function WhatsAppButton() {
  // 🔴 IMPORTANT: country code + number, NO +, NO spaces
  const phoneNumber = "917022215439";
  const message =
    "Hello, I am interested in your Projects";

  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
      />
    </a>
  );
}
